module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/scss/fonts/glyphicons-halflings-regular.eot
// module id = ../../../../../src/scss/fonts/glyphicons-halflings-regular.eot
// module chunks = styles